import { supabaseClient, useUser } from '@auth-v2';
import { useQuery } from '@tanstack/react-query';

import { fetchStudent } from '@data';

export const getStudentKey = (userId: string) => ['student', userId] as const;

export const useStudent = (golferId?: string) => {
    const { data: user } = useUser();
    return useQuery({
        queryKey: getStudentKey(golferId ?? ''),
        queryFn: () => fetchStudent(supabaseClient, golferId!),
        enabled: !!user && !!golferId && user.id !== golferId,
        retry: false,
    });
};
